import React from 'react';
import { Folder, FolderOpen } from '@lifeomic/chromicons';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  openFolder: {
    id: 'FolderIcon.openFolder',
    defaultMessage: 'Open Folder',
  },
  closedFolder: {
    id: 'FolderIcon.closedFolder',
    defaultMessage: 'Closed Folder',
  },
});

const useStyles = makeStyles(theme => ({
  folderIcon: {
    marginRight: theme.spacing(1),
  },
}));

interface FolderIconProps {
  isExpanded: boolean;
}

const FolderIcon: React.FC<FolderIconProps> = ({ isExpanded }) => {
  const styles = useStyles();
  const intl = useIntl();

  const Icon = isExpanded ? FolderOpen : Folder;

  return (
    <span
      className={styles.folderIcon}
      role="img"
      aria-label={
        isExpanded
          ? intl.formatMessage(messages.openFolder)
          : intl.formatMessage(messages.closedFolder)
      }
    >
      <Icon width={20} height={20} />
    </span>
  );
};

export { FolderIcon };
